/* eslint-disable no-param-reassign */

export const phoneMask = (value: string, locale: 'pt-BR' | 'en' = 'pt-BR') => {
  if (!value) return ''

  if (locale === 'en') {
    value = value.replace(/\D/g, '')
    value = value.replace(/(\d{1})(\d)/, '+$1 $2')
    value = value.replace(/(\d{3})(\d)/, '($1) $2')
    value = value.replace(/(\d{3})(\d)/, '$1 $2')
    value = value.replace(/(\d{4})$/, '$1')
    return value
  }

  value = value.replace(/\D/g, '')
  value = value.replace(/(\d{2})(\d)/, '($1) $2')
  value = value.replace(/(\d)(\d{4})$/, '$1-$2')
  return value
}
